export default {
  product: {
    name: 'Comprar tarjeta de regalo',
  },
  description: {
    items: {
      delivery: 'Enviada inmediatamente por correo electrónico como PDF',
      usage: {
        online: 'Canjeable solo en línea',
        online_and_store: 'Canjeable en línea y en el restaurante',
      },
      value: 'Importes flexibles de {{from}} a {{to}}',
    },
  },
};
